export enum ROLES {
  ANALYST = 'ANALYST',
  ORGANIZATION_ADMIN = 'ORGANIZATION_ADMIN',
  VIEWER = 'VIEWER',
  SUPER_ADMIN = 'SUPER_ADMIN',
}

export enum RolesLowerCase {
  ANALYST = 'Analyst',
  ORGANIZATION_ADMIN = 'Organization Admin',
  VIEWER = 'Viewer',
  SUPER_ADMIN = 'Super Admin',
}

export const RolesByTitle = {
  Analyst: 'ANALYST',
  'Organization Admin': 'ORGANIZATION_ADMIN',
  Viewer: 'VIEWER',
  'Super Admin': 'SUPER_ADMIN',
};
